// extracted by mini-css-extract-plugin
module.exports = {"aspectRatio":"maintainAspectRatio_aspectRatio__LsBFb"};